import Marionette from 'backbone.marionette';
import Navigator from 'app';
import membersLayoutTmpl from '../templates/members_home_layout.tpl';
import mapItemView from '../views/map_itemview';
export default Marionette.LayoutView.extend({
  template: membersLayoutTmpl,
  events: {
    // "click #map-tab": "triggerMap"
    "shown.bs.tab": "triggerTab"
  },
  regions: {
    membersRegion: "#members-browse-region",
    mapRegion: "#map-region"
  },
  triggerTab: function (e) {
    var target = e.target.id;
    if (target === "map-tab") {
      Navigator.vent.trigger("map:show", this);
    } else if (target === "members-browse-tab") {
      Navigator.vent.trigger("member:home:show", null, this);
    }
  }
});